'use client'

import { useState } from 'react'
import Image from 'next/image'
import { BOT_ANIMATION_FALLBACK, BOT_FULL_ANIMATION } from '@constants/contactUs.constants'
import styles from './BotChannel.module.scss'

const BotAnimation = ({ onCtaClick }) => {
  const [hasError, setHasError] = useState(false)
  const theme = 'white' // todo: update once theme is integrated

  if (hasError) {
    return (
      <div className={styles.botAnimationFallback} onClick={() => onCtaClick()}>
        <Image src={BOT_ANIMATION_FALLBACK} alt="bot-animation-fallback" width={326} height={326} />
      </div>
    )
  }

  return (
    <div className={styles.botAnimation} onClick={() => onCtaClick()}>
      <video
        src={BOT_FULL_ANIMATION[theme]}
        autoPlay
        loop
        muted
        playsInline
        className={styles.botAnimationVideo}
        style={{
          width: '100%',
          height: '100%',
        }}
        onError={() => setHasError(true)}
      />
    </div>
  )
}

export default BotAnimation
